import { Component, EventEmitter, Input, Output, forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import Cropper from 'cropperjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function CropperComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "img", 2, 3);
    ɵngcc0.ɵɵlistener("load", function CropperComponent_div_0_Template_img_load_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onImageLoad($event); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.dataUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
class CropperComponent {
    constructor() {
        this.crop = new EventEmitter();
        this.cropMove = new EventEmitter();
        this.cropStart = new EventEmitter();
        this.cropEnd = new EventEmitter();
        this.ready = new EventEmitter();
        this.zoom = new EventEmitter();
        this.init = new EventEmitter();
        this.fail = new EventEmitter();
        this.fileChange = new EventEmitter();
        this.options = /** @type {?} */ ({});
        this.data = /** @type {?} */ ({});
        this.propagateChange = (value) => value;
    }
    /**
     * @return {?}
     */
    get imageFile() {
        return this.originalFile;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set imageFile(value) {
        delete this.dataUrl;
        this.destroyCropperIfExists();
        if (!value) {
            return;
        }
        if (['image/gif', 'image/jpeg', 'image/png'].indexOf(value.type) === -1) {
            this.fail.emit(new Error('Invalid input file type'));
            return;
        }
        /** @type {?} */
        const reader = new FileReader();
        reader.onload = () => {
            this.dataUrl = reader.result;
        };
        this.originalFile = value;
        reader.readAsDataURL(this.originalFile);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set imageUrl(value) {
        delete this.dataUrl;
        this.destroyCropperIfExists();
        if (!value) {
            return;
        }
        this.dataUrl = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.data = value;
        if (this.data && this.cropper) {
            this.cropper.setData(this.data);
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @return {?}
     */
    registerOnTouched() { }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyCropperIfExists();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onImageLoad(event) {
        /** @type {?} */
        const img = /** @type {?} */ (event.target);
        this.destroyCropperIfExists();
        if ((this.options.minCropWidth && img.naturalWidth < this.options.minCropWidth)
            || (this.options.minCropHeight && img.naturalHeight < this.options.minCropHeight)) {
            delete this.dataUrl;
            this.fail.emit(new Error('Input image is too small'));
            return;
        }
        this.isReady = false;
        this.cropper = new Cropper(img, Object.assign({
            crop: this.onCrop.bind(this),
            cropmove: this.onCropMove.bind(this),
            cropstart: this.onCropStart.bind(this),
            cropend: this.onCropEnd.bind(this),
            ready: this.onReady.bind(this),
            zoom: this.onZoom.bind(this),
        }, this.options));
        this.init.emit(this.cropper);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCrop(event) {
        if (this.options.viewMode !== 0) {
            this.correctCropArea();
        }
        if (this.isReady) {
            this.update();
        }
        this.crop.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCropMove(event) {
        if (this.options.viewMode === 0) {
            this.correctCropArea();
        }
        this.update();
        this.cropMove.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCropStart(event) {
        this.update();
        this.cropStart.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCropEnd(event) {
        this.correctCropArea();
        this.updateFile();
        this.update();
        this.cropEnd.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onReady(event) {
        if (this.data) {
            this.cropper.setData(this.data);
            this.correctCropArea();
        }
        else {
            this.correctCropArea();
            this.update();
        }
        this.isReady = true;
        this.ready.emit(event);
        this.updateFile();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onZoom(event) {
        this.update();
        this.zoom.emit(event);
    }
    /**
     * @return {?}
     */
    updateFile() {
        /** @type {?} */
        let name = 'cropped_file';
        if (typeof this.dataUrl === 'string') {
            /** @type {?} */
            const urlParams = this.dataUrl.split('/');
            name = urlParams[urlParams.length - 1];
        }
        /** @type {?} */
        const mimeType = (this.options.outputOptions && this.options.outputOptions.mimeType) || 'image/png';
        /** @type {?} */
        const qualityArgument = (this.options.outputOptions && this.options.outputOptions.qualityArgument) || 0.9;
        this.cropper.getCroppedCanvas().toBlob((blob) => {
            blob.lastModifiedDate = new Date();
            blob.name = this.originalFile ? this.originalFile.name : name;
            this.fileChange.emit(blob);
        }, mimeType, qualityArgument);
    }
    /**
     * @return {?}
     */
    correctCropArea() {
        /** @type {?} */
        const data = this.cropper.getData();
        if (data.height < this.options.minCropHeight || data.width < this.options.minCropWidth) {
            data.width = Math.max(data.width, this.options.minCropWidth || 0);
            data.height = Math.max(data.height, this.options.minCropHeight || 0);
            this.cropper.setData(data);
        }
    }
    /**
     * @return {?}
     */
    update() {
        this.data = this.cropper.getData();
        this.propagateChange(this.data);
    }
    /**
     * @return {?}
     */
    destroyCropperIfExists() {
        if (!this.cropper) {
            return;
        }
        this.cropper.destroy();
        delete this.cropper;
    }
}
CropperComponent.ɵfac = function CropperComponent_Factory(t) { return new (t || CropperComponent)(); };
CropperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CropperComponent, selectors: [["lib-cropper"]], inputs: { options: "options", imageFile: "imageFile", imageUrl: "imageUrl" }, outputs: { crop: "crop", cropMove: "cropMove", cropStart: "cropStart", cropEnd: "cropEnd", ready: "ready", zoom: "zoom", init: "init", fail: "fail", fileChange: "fileChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CropperComponent),
                multi: true
            }
        ])], decls: 1, vars: 1, consts: [["class", "cropper-component", 4, "ngIf"], [1, "cropper-component"], ["alt", "image", 3, "src", "load"], ["image", ""]], template: function CropperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CropperComponent_div_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.dataUrl);
    } }, directives: [ɵngcc1.NgIf], styles: [".cropper-component[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100%;max-height:100%} {}  .cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}  .cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}  .cropper-canvas,   .cropper-crop-box,   .cropper-drag-box,   .cropper-modal,   .cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}  .cropper-canvas,   .cropper-wrap-box{overflow:hidden}  .cropper-drag-box{background-color:#fff;opacity:0}  .cropper-modal{background-color:#000;opacity:.5}  .cropper-view-box{display:block;height:100%;outline:#eee solid 1px;overflow:hidden;width:100%}  .cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}  .cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}  .cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}  .cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}  .cropper-center:after,   .cropper-center:before{background-color:#eee;content:' ';display:block;position:absolute}  .cropper-center:before{height:1px;left:-3px;top:0;width:7px}  .cropper-center:after{height:7px;left:0;top:-3px;width:1px}  .cropper-face,   .cropper-line,   .cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}  .cropper-face{background-color:#fff;left:0;top:0}  .cropper-line{background-color:#39f}  .cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}  .cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}  .cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}  .cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}  .cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}  .cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}  .cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}  .cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}  .cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}  .cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}  .cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}  .cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}  .cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){  .cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){  .cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){  .cropper-point.point-se{height:5px;opacity:.75;width:5px}}  .cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:' ';display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}  .cropper-invisible{opacity:0}  .cropper-bg{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC)}  .cropper-hide{display:block;height:0;position:absolute;width:0}  .cropper-hidden{display:none!important}  .cropper-move{cursor:move}  .cropper-crop{cursor:crosshair}  .cropper-disabled .cropper-drag-box,   .cropper-disabled .cropper-face,   .cropper-disabled .cropper-line,   .cropper-disabled .cropper-point{cursor:not-allowed}  .cropper-line,   .cropper-point,   .cropper-point.point-se::before{background-color:#eee}"] });
CropperComponent.propDecorators = {
    crop: [{ type: Output }],
    cropMove: [{ type: Output }],
    cropStart: [{ type: Output }],
    cropEnd: [{ type: Output }],
    ready: [{ type: Output }],
    zoom: [{ type: Output }],
    init: [{ type: Output }],
    fail: [{ type: Output }],
    fileChange: [{ type: Output }],
    options: [{ type: Input }],
    imageFile: [{ type: Input, args: ['imageFile',] }],
    imageUrl: [{ type: Input, args: ['imageUrl',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CropperComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cropper',
                template: `<div class="cropper-component" *ngIf="dataUrl">
  <img #image alt="image" [src]="dataUrl" (load)="onImageLoad($event)"/>
</div>
`,
                styles: [`.cropper-component img{max-width:100%;max-height:100%}::ng-deep{/*!
 * Cropper.js v1.4.0
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-06-01T15:18:09.891Z
 */}::ng-deep .cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}::ng-deep .cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}::ng-deep .cropper-canvas,::ng-deep .cropper-crop-box,::ng-deep .cropper-drag-box,::ng-deep .cropper-modal,::ng-deep .cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}::ng-deep .cropper-canvas,::ng-deep .cropper-wrap-box{overflow:hidden}::ng-deep .cropper-drag-box{background-color:#fff;opacity:0}::ng-deep .cropper-modal{background-color:#000;opacity:.5}::ng-deep .cropper-view-box{display:block;height:100%;outline:#eee solid 1px;overflow:hidden;width:100%}::ng-deep .cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}::ng-deep .cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}::ng-deep .cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}::ng-deep .cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}::ng-deep .cropper-center:after,::ng-deep .cropper-center:before{background-color:#eee;content:' ';display:block;position:absolute}::ng-deep .cropper-center:before{height:1px;left:-3px;top:0;width:7px}::ng-deep .cropper-center:after{height:7px;left:0;top:-3px;width:1px}::ng-deep .cropper-face,::ng-deep .cropper-line,::ng-deep .cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}::ng-deep .cropper-face{background-color:#fff;left:0;top:0}::ng-deep .cropper-line{background-color:#39f}::ng-deep .cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}::ng-deep .cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}::ng-deep .cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}::ng-deep .cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}::ng-deep .cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}::ng-deep .cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}::ng-deep .cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}::ng-deep .cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}::ng-deep .cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}::ng-deep .cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}::ng-deep .cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}::ng-deep .cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}::ng-deep .cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){::ng-deep .cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){::ng-deep .cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){::ng-deep .cropper-point.point-se{height:5px;opacity:.75;width:5px}}::ng-deep .cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:' ';display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}::ng-deep .cropper-invisible{opacity:0}::ng-deep .cropper-bg{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC)}::ng-deep .cropper-hide{display:block;height:0;position:absolute;width:0}::ng-deep .cropper-hidden{display:none!important}::ng-deep .cropper-move{cursor:move}::ng-deep .cropper-crop{cursor:crosshair}::ng-deep .cropper-disabled .cropper-drag-box,::ng-deep .cropper-disabled .cropper-face,::ng-deep .cropper-disabled .cropper-line,::ng-deep .cropper-disabled .cropper-point{cursor:not-allowed}::ng-deep .cropper-line,::ng-deep .cropper-point,::ng-deep .cropper-point.point-se::before{background-color:#eee}`],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CropperComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { crop: [{
            type: Output
        }], cropMove: [{
            type: Output
        }], cropStart: [{
            type: Output
        }], cropEnd: [{
            type: Output
        }], ready: [{
            type: Output
        }], zoom: [{
            type: Output
        }], init: [{
            type: Output
        }], fail: [{
            type: Output
        }], fileChange: [{
            type: Output
        }], options: [{
            type: Input
        }], imageFile: [{
            type: Input,
            args: ['imageFile']
        }], imageUrl: [{
            type: Input,
            args: ['imageUrl']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgxCropperJsModule {
}
NgxCropperJsModule.ɵfac = function NgxCropperJsModule_Factory(t) { return new (t || NgxCropperJsModule)(); };
NgxCropperJsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCropperJsModule });
NgxCropperJsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCropperJsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [CropperComponent],
                exports: [CropperComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCropperJsModule, { declarations: function () { return [CropperComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CropperComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { CropperComponent, NgxCropperJsModule };

